type Stats = {
  readonly open: number;
  readonly gate1: number;
  readonly gate2: number;
  readonly clarification: number;
};

type Props = {
  readonly stats: Stats;
};

export function Hero({ stats }: Props) {
  return (
    <div className="page-hero">
      <div className="hero-grid">
        <div>
          <div className="eyebrow-lime">
            <span className="dot" />
            Reviewer-Inbox
          </div>
          <h1 className="page-title">
            Anforderungen,
            <br />
            aufgeräumt.
          </h1>
          <p className="page-sub">
            KI-gestützter Informationsaufbereitungs-Hub. Du prüfst Klassifikationen,
            gibst Aufbereitungen frei und übergibst saubere Informationspakete als
            Markdown.
          </p>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <div className="v">{stats.open}</div>
            <div className="l">Offen gesamt</div>
          </div>
          <div className="stat">
            <div className="v lime">{stats.gate1}</div>
            <div className="l">Gate 1 · Klassifikation</div>
          </div>
          <div className="stat">
            <div className="v lime">{stats.gate2}</div>
            <div className="l">Gate 2 · Finale</div>
          </div>
          <div className="stat">
            <div className="v">{stats.clarification}</div>
            <div className="l">Rückfrage offen</div>
          </div>
        </div>
      </div>
    </div>
  );
}
